import { REPORT_STATE_SELECTOR } from "./utils";
import { API_ROUTES } from "../../../../../system/constants/apiRoutes";
import { REPORT_COLUMNS_KEY, REPORT_DATE_KEY } from "./utils";
import { updateReportFilters } from "./redux/actions";

export const config = {
  columns: [
    "affiliate_geo_details",
    "partner_id",
    "partner_login",
    "reg_date",
    "deposits",
    "withdraws",
    "multiacc_count",
    "regs",
    "first_deposits",
    "deposits_count",
    "rd",
    "rd_percent",
    "ngr",
    "ggr",
    "royalty",
    "transaction_commission",
    "rs_income",
    "partner_income",
    "assured_income",
  ],
  subtotals: [
    "hits",
    "hosts",
    "regs",
    "withdraws",
    "multiacc_count",
    "rd",
    "deposits_count",
    "deposits",
    "bonus",
    "gamers",
    "rounds",
    "full_income",
    "comppoints",
    "ltv",
    "full_profit",
    "first_deposits",
    "qualified_players",
    "landing_hits",
    "landing_hosts",
    "ngr",
    "ggr",
    "royalty",
    "transaction_commission",
    "rs_income",
    "partner_income",
    "assured_income",
  ],
  hiddenColumns: [],
  filteredColumns: [
    "partner_id",
    "partner_login",
    "status",
    "role",
    "reg_date",
    "cash_type_label",
    "wallet",
    "traffic_type",
    "deposits",
    "withdraws",
    "comppoints",
    "multiacc_count",
    "regs",
    "first_deposits",
    "deposits_count",
    "rd",
    "rd_percent",
    "ngr",
    "ggr",
    "royalty",
    "transaction_commission",
    "rs_income",
    "partner_income",
    "assured_income",
  ],
  columnsKey: REPORT_COLUMNS_KEY,
  dateKey: REPORT_DATE_KEY,
  stateSelector: REPORT_STATE_SELECTOR,
  api: API_ROUTES.reports.affiliates_geo.path,
  apiKey: API_ROUTES.reports.affiliates_geo.key,
  fileName: API_ROUTES.reports.affiliates_geo.filename,
  dispatchCallback: updateReportFilters,
};
